import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.FedwireFundResponse,
  FedwireFund: (params: vp.FedwireFundRequest) => void,
  reset: () => void,
  FedwireFundAsync: (params: vp.FedwireFundRequest) => Promise<vp.FedwireFundResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostFedwireFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldFedwireFund, setShouldFedwireFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.FedwireFundRequest>({
    AccountNumber: '',
    ABARoutingNumber: '',
    Amount: 0,
    FirstName: '',
    LastName: '',
    CompanyName: '',
    Address1: '',
    City: '',
    State: '',
    Country: '',
    ZipCode: '',
  });
  const [response, setResponse] = useState<vp.FedwireFundResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldFedwireFund) return () => {};

    const PostFedwireWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postFedwireFund(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldFedwireFund) void PostFedwireWithdraw();
    setShouldFedwireFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldFedwireFund]);

  return [
    response,
    (_params: vp.FedwireFundRequest) => {
      setParams(_params);
      setShouldFedwireFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldFedwireFund(false);
    },
    async (params: vp.FedwireFundRequest) => {
      return api.postFedwireFund(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostFedwireFund);
